module.exports = __webpack_public_path__ + "static/media/7_fripulia1_52.6_3.24.fd6779d5.png";